import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Caja from './pages/caja';
import DashboardPrincipal from './pages/dashboard-principal';
import OrderManagement from './pages/order-management';
import QuotesManagement from './pages/quotes-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<DashboardPrincipal />} />
        <Route path="/caja" element={<Caja />} />
        <Route path="/dashboard-principal" element={<DashboardPrincipal />} />
        <Route path="/order-management" element={<OrderManagement />} />
        <Route path="/quotes-management" element={<QuotesManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
